import buildApp from './app';
import HawkCatcher from '@hawk.so/javascript'
import config from './config.js'
import ApiSource from './api/ApiSource.js'
const { app, router, store } = buildApp();

const HAWK_BOTS = /(bot|crawler|spider|webindexer)\/\d|facebookexternalhit/i;
const HAWK_NOISE_TITLE = /^(Script error\.?|ResizeObserver loop.*|\[object Event\]|Load failed|Failed to fetch)$|Permissions/;
const HAWK_NOISE_FRAME = /extractSchemaValuesFromSchemaOrg|extractFilteredSchemaValuesFromMicroData|chrome:\/\/|-extension:\/\/|top-fwz1\.mail\.ru|@vkid\/sdk/;

if (import.meta.env.PROD) {
    const hawk = new HawkCatcher({
        token: config.hawkToken,
        vue: app,
        release: window.HAWK_RELEASE,
        beforeSend(event) {
            const frames = (event.backtrace ?? []).map(frame => `${frame.file} ${frame.function ?? ''}`).join('\n');
            if (HAWK_BOTS.test(event.addons?.userAgent ?? '') || HAWK_NOISE_TITLE.test(event.title) || HAWK_NOISE_FRAME.test(frames)) {
                return false;
            }
            return event;
        },
    })
}



if (window.__INITIAL_STATE__) {
    store.replaceState(__INITIAL_STATE__);
    document.getElementById('initialDataScript').remove();
}


router.isReady().then(async () => {
    // await  app.config.globalProperties.$store.dispatch('auth/initAuth')
    await app.use(ApiSource);
    await app.config.globalProperties.$store.dispatch('startUpMount');
    app.mount('#app', true)
});



